<template>
  <tr-dialog
    ref="modal"
    name="terms-of-use-dialog"
    :hide-cancel-button="true"
    :has-its-own-buttons="true"
    title="Atualização da Política de Privacidade"
  >
    Atualizamos nossa <a
      href="https://legal.transfeera.com/politica-de-privacidade/"
      target="_blank"
    >Política de Privacidade</a> para refletir nos nossos serviços e maior transparência no
    tratamento de dados. Ao continuar, você concorda com os novos termos descritos na política.
    <tr-dialog-buttons-container>
      <bg-columns h-align="right">
        <bg-column width="content">
          <bg-button
            variant="outline"
            @click="remindLater"
          >
            Lembrar mais tarde
          </bg-button>
        </bg-column>
        <bg-column width="content">
          <bg-button
            type="submit"
            variant="solid"
            @click="acceptTerms"
          >
            Li e concordo
          </bg-button>
        </bg-column>
      </bg-columns>
    </tr-dialog-buttons-container>
  </tr-dialog>
</template>

<script setup>
import checkpoint from '@/commons/resources/checkpoint';
import checkpoints from '@/commons/constants/checkpoint';
import { BgButton, BgColumn, BgColumns } from '@transfeeradev/bridge';
import { ref } from 'vue';

const modal = ref(null);

const open = () => {
  modal.value.open();
};

const close = () => {
  checkpoint.create(checkpoints.PRIVACY_POLICY_CLOSED);
  modal.value.close();
};

const openIfNotAccepted = async () => {
  const { exists } = await checkpoint.existsInCompany(checkpoints.PRIVACY_POLICY_ACCEPTED);
  if (!exists) {
    open();
  }
};

const remindLater = () => {
  checkpoint.create(checkpoints.PRIVACY_POLICY_REMIND_LATER);
  modal.value.close();
};

const acceptTerms = async () => {
  checkpoint.create(checkpoints.PRIVACY_POLICY_ACCEPTED);
  modal.value.close();
};

defineExpose({
  open,
  close,
  openIfNotAccepted
});
</script>
